import '../../css/style.scss';
import { UIWHeaderController } from '../ui_html/header/UIWHeaderController.ts';
import { UISidebarController } from '../ui_html/sidebar/UISidebarController.ts';
import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { EntrySingletonPageShared } from '../../EntrySingletonPageShared.ts';
import { UIChampionship26Controller } from '../../../shared/scripts/ui_cc/UIChampionship26Controller.ts';
void init();
async function init() {
    EntryShared.initializeAudio();
    await EntryShared.initializeEntry();
    const headerController = new UIWHeaderController();
    new UISidebarController();
    new UIChampionship26Controller();
    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController);
    EntryShared.sendPageVisitAnalyticEvent();
}
